import { eventbus } from '../packages/eventbus';

export const commonEventChannel = eventbus<{
  onSuccessAction: () => void;
}>();
